import React from "react";
import styled from "styled-components";
import { Title, SubTitle } from "components/generic/form/service";

const Wrap = styled.div`
  max-width: ${({ width = "35rem" }) => width};
  width: 100%;
  margin: 0 auto;
`;

const Container = styled.div`
  background-color: #f9f7f2;
  margin: 0 auto;
  width: 98%;
  min-height: 379px;
  z-index: 1000;
`;

const texts = {
  "%2F%3Ftitle%3D%2522earn_about_investment_banking%2522": {
    title: "Instantly get advice from an insider",
    subTitle:
      "Schedule a call with an insider below to *learn* how you stack up, get honest feedback, and get personalized tips to land the job."
  },
  "%2F%3Ftitle%3D%2522land_a_summer_internship%2522": {
    title: "Land a Summer Internship",
    subTitle: `Schedule a call with an insider below to learn what life is like on the inside, how you stack up, and about upcoming recruiting timelines.`
  },
  "%2F%3Ftitle%3D%2522land_a_full-time_job%2522": {
    title: "Land a full-time job",
    subTitle: `Schedule a call with an insider below to learn what life is like on the inside, how you stack up, and about upcoming recruiting timelines`
  },
  "%2F%3Ftitle%3D%2522transition_from_another_firm%2522": {
    title: "Transition from another industry",
    subTitle: `Schedule a call with an insider below to learn how you can lateral into banking from any industry, and get honest advice and personalized tips to land the job.`
  }
};

const TextWrap = styled.div`
  padding-left: 180px;
  @media (max-width: 680px) {
    padding-left: 0px;
  }
  @media only screen and (max-width: 1300px) {
    padding-left: 80px;
  }
  @media only screen and (min-width: 1900px) {
    padding-left: 300px;
  }
`;

const Text = ({ backLink, title, subtitle }) => {
  const content = backLink && texts[backLink];
  if (content)
    return (
      <TextWrap className="pa3-ns pv4-ns mt3 mt0-ns center tl-ns tc">
        <Title>{content.title}</Title>
        <SubTitle>{content.subTitle}</SubTitle>
      </TextWrap>
    );
  return (
    <TextWrap className="pa3-ns pv4-ns mt0-ns mt3  center tl-ns tc">
      {title} {subtitle}
    </TextWrap>
  );
};

export default ({ children, wrapWidth, id, title, subtitle, backLink }) => (
  <Wrap width={wrapWidth}>
    <Container id={id} className="pa4-ns pl0-ns pa2">
      <div className="pa4-ns pl0-ns pv4 center tl-ns tc mb5-ns">
        {backLink ? (
          <Text backLink={backLink} title={title} subtitle={subtitle} />
        ) : (
          <div className="pa4-ns pl0-ns pv4  center tl-ns tc">
            {title} {subtitle}
          </div>
        )}
      </div>
      {children}
    </Container>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/TitleContainer/index.js